import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForMediaEmbedComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'embedService',
    'headline',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'embedService',
      type: 'relation',
    },
    {
      property: 'channels',
      type: 'relation',
    },
    {
      property: 'cmsLanguageId',
      type: 'translate-value',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
